import { PayloadUserAuth } from '../../payload/payload-types.zod'
import z from 'zod'

export const userAuthDbSchema = PayloadUserAuth

export const createUserAuthSchema = userAuthDbSchema
  .omit({
    createdAt: true,
    encryptedPid: true,
    updatedAt: true,
  })
  .extend({
    pid: z.string(),
  })

export const createUserAuthDbSchema = userAuthDbSchema.omit({
  createdAt: true,
  updatedAt: true,
})

export type UserAuthDb = z.infer<typeof userAuthDbSchema>

export type CreateUserAuth = z.infer<typeof createUserAuthSchema>

export type CreateUserAuthDb = z.infer<typeof createUserAuthDbSchema>
